module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/axios/index.js
// module id = 71
// module chunks = 1